
import AppCreateCompanyCard from "@/components/company/CompanyCreateCard.vue";
import Vue from "vue";

export default Vue.extend({
	methods: {
		openCreatedCompany(companyId:number){
			this.$router.push("/companies/" + companyId + "/edit");
		},
	},
	components: {
		AppCreateCompanyCard
	}
});
